import { render, staticRenderFns } from "./wishForm.vue?vue&type=template&id=012808ac&scoped=true"
import script from "./wishForm.vue?vue&type=script&lang=js"
export * from "./wishForm.vue?vue&type=script&lang=js"
import style0 from "./wishForm.vue?vue&type=style&index=0&id=012808ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012808ac",
  null
  
)

export default component.exports